export default "/img/HT.27d56aa8710493024d67b36f40fac2b2.png";